import React from 'react';
import ImageSrcsetContainer from './ImageSrcsetContainer';

var ImageSrcset = function ImageSrcset(_ref) {
  var image1x = _ref.image1x,
      image2x = _ref.image2x,
      alt = _ref.alt,
      imageFluid = _ref.imageFluid,
      className = _ref.className;
  return /*#__PURE__*/React.createElement(ImageSrcsetContainer, {
    src: image1x,
    srcSet: image1x + " 1x, " + image2x + " 2x",
    alt: alt,
    imageFluid: imageFluid,
    className: className
  });
};

ImageSrcset.defaultProps = {
  imageFluid: true,
  alt: null,
  className: null
};
export default ImageSrcset;